<template>
  <div class="SiteSettingsOutgoingHooks">
    <v-data-table
      dark
      :headers="headers"
      :items="outgoingHooks"
      @click:row="rowClicked"
      class="SiteSettingsOutgoingHooks__table"
    >
      <template v-slot:item.event="{ item }">
        <p class="capitalize">{{ item.event }}</p>
      </template>
      <template v-slot:item.form="{ item }">
        <span v-if="item.form_id || item.form_scope">
          <span v-if="item.form_human_name">{{ item.form_human_name }}</span>
          <span v-else-if="item.form_scope">{{ item.form_scope }}</span>
          <span v-else>-</span>
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <v-btn icon @click.stop="testHook(item)" dark class="mr-2">
            <v-icon>mdi-play</v-icon>
          </v-btn>
        <v-btn icon @click.stop="deleteHook(item)" dark>
          <v-icon>delete</v-icon>
        </v-btn>
        </div>
      </template>
    </v-data-table>
    <br />
  </div>
</template>

<script>
import { MODAL_SITE_HOOK, MODAL_WEBHOOK_TESTER } from '@/components/Modals'
export default {
  name: 'SiteSettingsOutgoindHooks',
  props: {
    outgoingHooks: Array,
  },
  computed: {
    headers() {
      return [
        {
          text: 'Method',
          align: 'start',
          sortable: false,
          value: 'http_method',
        },
        {
          text: 'URL',
          value: 'url',
        },
        { text: 'Event', value: 'event' },
        {
          text: 'Form',
          value: 'form',
          sortable: false,
        },
        {
          text: 'Updated At',
          value: 'updated_at',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ]
    },
  },
  methods: {
    deleteHook(item) {
      this.$store.dispatch('sites/removeHook', item.id)
    },
    rowClicked(row) {
      this.$store.commit('application/openModal', {
        component: MODAL_SITE_HOOK,
        props: {
          webhook: row,
        },
      })
    },
    async testHook(webhook) {
      try {
        this.$store.commit('application/openModal', {
          component: MODAL_WEBHOOK_TESTER,
          props: {
            webhook: webhook,
          },
        })
      } catch (error) {
        console.error('Error testing webhook:', error)
      }
    },
  },
}
</script>

<style lang="scss">
$style: SiteSettingsOutgoingHooks;
.#{$style} {
  margin-top: 16px;
  &__table {
    &.theme--dark.v-data-table {
      background-color: $NNotice;
      border-radius: 8px;
    }
  }
}
.capitalize {
  white-space: nowrap;
  text-transform: capitalize;
}
</style>
